import { makeStyles } from '@material-ui/core/styles';
const useGlobalStyles = makeStyles(theme => ({
    cardHeader: () => ({
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        position: 'relative'
    }),
    tooltipPopper: {
        fontSize: '12px',
    },
}));

export default useGlobalStyles;
